/* Landing ecommerce · JS aislado, sin dependencias */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initMenu(scope) {
    scope.querySelectorAll('[data-lp-menu-toggle]').forEach(function (btn) {
      if (btn.dataset.lpBound) return;
      btn.dataset.lpBound = '1';
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      function close(focusBtn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', btn.dataset.labelOpen);
        nav.hidden = true;
        if (focusBtn) btn.focus();
      }
      function open() {
        btn.setAttribute('aria-expanded', 'true');
        btn.setAttribute('aria-label', btn.dataset.labelClose);
        nav.hidden = false;
      }
      btn.addEventListener('click', function () {
        btn.getAttribute('aria-expanded') === 'true' ? close(false) : open();
      });
      nav.addEventListener('click', function (e) {
        if (e.target.closest('a')) close(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') close(true);
      });
      if (window.matchMedia) {
        var mq = window.matchMedia('(min-width: 990px)');
        var onChange = function (e) { if (e.matches) close(false); };
        mq.addEventListener ? mq.addEventListener('change', onChange) : mq.addListener(onChange);
      }
    });
  }

  function initReveal(scope) {
    var els = scope.querySelectorAll('[data-lp-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCharts(scope) {
    scope.querySelectorAll('[data-lp-chart]').forEach(function (chart) {
      if (chart.dataset.lpBound) return;
      chart.dataset.lpBound = '1';
      var tip = chart.querySelector('[data-lp-tip]');
      var plot = chart.querySelector('.lp-chart__plot');
      var points = Array.prototype.slice.call(chart.querySelectorAll('[data-lp-point]'));
      if (!tip || !points.length) return;
      var svg = chart.querySelector('.lp-chart__svg');
      var axis = Number(chart.dataset.axis);
      var guide = chart.querySelector('[data-lp-guide]');
      var comparisonPoint = chart.querySelector('[data-lp-comparison-point]');
      var active = points[points.length - 1];
      var formatMoney = function (amount) {
        return '$' + new Intl.NumberFormat('en-US', {minimumFractionDigits: amount === 0 ? 0 : 2, maximumFractionDigits: 2}).format(amount) + ' MXN';
      };
      var formatChange = function (current, previous) {
        var change = (current / previous - 1) * 100;
        var magnitude = Math.abs(change);
        return new Intl.NumberFormat('es-ES', {maximumFractionDigits: 1}).format(magnitude >= 1000 ? magnitude / 1000 : magnitude) + (magnitude >= 1000 ? ' mil %' : ' %');
      };
      function setChange(element, current, previous) {
        var descending = current < previous;
        element.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" style="display:inline-block;vertical-align:-2px;margin-right:4px"><path d="' + (descending ? 'M5 5l14 14M9 19h10V9' : 'M5 19L19 5M9 5h10v10') + '" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        element.appendChild(document.createTextNode(formatChange(current, previous)));
      }
      function drawCurve(coordinates, className) {
        var path = 'M' + coordinates[0].join(',');
        for (var n = 1; n < coordinates.length; n++) {
          var before = coordinates[n - 1], after = coordinates[n], dx = (after[0] - before[0]) / 3;
          path += ' C' + (before[0] + dx) + ',' + before[1] + ' ' + (after[0] - dx) + ',' + after[1] + ' ' + after.join(',');
        }
        var curve = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        curve.setAttribute('class', className);
        curve.setAttribute('d', path);
        svg.appendChild(curve);
      }
      var line = svg.querySelector('.lp-chart__line');
      if (line && axis > 0) {
        line.remove();
        drawCurve(points.map(function (p) { return [parseFloat(p.style.left), 100 - Number(p.dataset.previous) / axis * 100]; }), 'lp-chart__comparison-line');
        drawCurve(points.map(function (p) { return [parseFloat(p.style.left), parseFloat(p.style.top)]; }), 'lp-chart__line');
      }
      var total = points.reduce(function (sum, p) { return sum + Number(p.dataset.sales); }, 0);
      var comparisonTotal = points.reduce(function (sum, p) { return sum + Number(p.dataset.previous); }, 0);
      var totalGrowth = chart.closest('figure').querySelector('[data-lp-total-growth]');
      if (totalGrowth && comparisonTotal > 0) {
        setChange(totalGrowth, total, comparisonTotal);
        totalGrowth.title = 'Variación frente a enero–septiembre de 2025';
        totalGrowth.classList.toggle('is-negative', total < comparisonTotal);
        totalGrowth.hidden = false;
      }
      function positionTip(p) {
        var x = parseFloat(p.style.left) / 100 * plot.clientWidth;
        var gap = 18;
        var card = chart.closest('figure').getBoundingClientRect();
        var bounds = plot.getBoundingClientRect();
        var right = card.right - bounds.left - 8;
        var left = x + gap;
        if (left + tip.offsetWidth > right) left = x - gap - tip.offsetWidth;
        left = Math.max(card.left - bounds.left + 8, Math.min(left, right - tip.offsetWidth));
        tip.style.left = left + 'px';
        tip.style.top = '8px';
      }
      function show(p) {
        active = p;
        points.forEach(function (point) {
          point.classList.toggle('is-active', point === p);
          point.setAttribute('aria-pressed', point === p ? 'true' : 'false');
        });
        var month = (p.dataset.short || p.dataset.label).replace(/\s*2026/, '').trim().slice(0, 3).toLowerCase();
        var previous = Number(p.dataset.previous), current = Number(p.dataset.sales);
        tip.querySelector('[data-lp-tip-label]').textContent = month + ' 2026';
        tip.querySelector('[data-lp-tip-value]').textContent = p.dataset.value;
        tip.querySelector('[data-lp-tip-previous-label]').textContent = month + ' 2025';
        tip.querySelector('[data-lp-tip-previous-value]').textContent = formatMoney(previous);
        var growth = tip.querySelector('[data-lp-tip-growth]');
        growth.hidden = previous <= 0;
        if (previous > 0) {
          setChange(tip.querySelector('[data-lp-tip-change]'), current, previous);
          growth.classList.toggle('is-negative', current < previous);
        }
        guide.style.left = p.style.left;
        guide.hidden = false;
        comparisonPoint.style.left = p.style.left;
        comparisonPoint.style.top = (100 - previous / axis * 100) + '%';
        comparisonPoint.hidden = false;
        tip.hidden = false;
        positionTip(p);
      }
      function selectNearest(e) {
        var bounds = plot.getBoundingClientRect();
        var x = (e.clientX - bounds.left) / bounds.width * 100;
        var nearest = points.reduce(function (best, p) {
          return Math.abs(parseFloat(p.style.left) - x) < Math.abs(parseFloat(best.style.left) - x) ? p : best;
        }, points[0]);
        if (nearest !== active || tip.hidden) show(nearest);
      }
      plot.addEventListener('pointermove', selectNearest);
      plot.addEventListener('pointerdown', selectNearest);
      points.forEach(function (p, i) {
        p.addEventListener('focus', function () { show(p); });
        p.addEventListener('click', function () { show(p); });
        p.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = points[i + 1];
          if (e.key === 'ArrowLeft') next = points[i - 1];
          if (e.key === 'Home') next = points[0];
          if (e.key === 'End') next = points[points.length - 1];
          if (next) { e.preventDefault(); next.focus(); }
          if (e.key === 'Escape') { tip.hidden = true; guide.hidden = true; comparisonPoint.hidden = true; }
        });
      });
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { if (!tip.hidden) positionTip(active); }).observe(plot);
      }
      show(active);
    });
  }

  function init(scope) {
    scope = scope || document;
    initMenu(scope);
    var progress=document.querySelector('[data-lp-reading-progress]');
    if(progress && !progress.dataset.bound){
      progress.dataset.bound='1';var pending=false;
      function update(){var height=document.documentElement.scrollHeight-window.innerHeight;progress.style.transform='scaleX('+ (height>0?Math.min(1,Math.max(0,window.scrollY/height)):0)+')';pending=false;}
      window.addEventListener('scroll',function(){if(!pending){pending=true;window.requestAnimationFrame(update);}},{passive:true});window.addEventListener('resize',update);update();
    }
    initReveal(scope);
    initCharts(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();


